/**
 * Checks which lead form path is available on the current site
 * Checks paths sequentially and stops at first available one
 * @param {string[]} pathsToCheck - Array of paths to check
 * @returns {Promise<string|null>} - First available path or null
 */
export const checkAvailableLeadFormPath = async (pathsToCheck = []) => {
	const checkPath = async (path) => {
		try {
			const response = await fetch(path, { method: 'HEAD' });
			return response.ok ? path : null;
		} catch (error) {
			return null;
		}
	};

	// Check paths sequentially - stop if path is available
	// eslint-disable-next-line no-restricted-syntax
	for (const path of pathsToCheck) {
		// eslint-disable-next-line no-await-in-loop
		const result = await checkPath(path);
		if (result) {
			return result; 
		}
	}
	
	return null;
};

export default checkAvailableLeadFormPath;
